import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { EnderecoResponse } from "app/shared/models/ei-models";

@Injectable({
    providedIn: 'root'
})
export class EnderecoService extends BaseService {
    private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Endereco/');

    constructor(private httpClient: HttpClient) {
        super();
    }

    getCep(cep: string, loader = true): Observable<EnderecoResponse> {
        return this.httpClient.get<EnderecoResponse>(this.controllerEndpoint.concat(cep), { headers: this.getHeader(loader) });
    }

}